// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LargeImageLoader_imageWrapper__u79E7"};